/* Boton de compartir. Delegado: sirve para los botones que ya estan en el DOM
   y para los que se pinten despues. */
(function(){
  var abierto = null;

  function datos(el){
    var raiz = el.closest('[data-share]');
    var url  = raiz.dataset.url || location.href;
    /* url absoluta: si viene relativa la resolvemos contra el dominio */
    url = new URL(url, location.origin).href;
    return { raiz: raiz, url: url, titulo: raiz.dataset.title || document.title };
  }

  function cerrar(){
    if(!abierto) return;
    abierto.querySelector('[data-share-menu]').hidden = true;
    abierto.querySelector('[data-share-toggle]').setAttribute('aria-expanded','false');
    abierto.classList.remove('is-open');
    abierto = null;
  }

  function abrirMenu(d){
    cerrar();
    var menu = d.raiz.querySelector('[data-share-menu]');
    var texto = d.titulo + ' — ' + d.url;
    menu.querySelector('[data-share-wa]').href   = 'https://wa.me/?text=' + encodeURIComponent(texto);
    menu.querySelector('[data-share-mail]').href = 'mailto:?subject=' + encodeURIComponent(d.titulo) +
                                                   '&body=' + encodeURIComponent(texto);
    menu.querySelector('[data-share-fb]').href   = 'https://www.facebook.com/sharer/sharer.php?u=' +
                                                   encodeURIComponent(d.url);
    menu.hidden = false;
    d.raiz.classList.add('is-open');
    d.raiz.querySelector('[data-share-toggle]').setAttribute('aria-expanded','true');
    abierto = d.raiz;
  }

  document.addEventListener('click', function(ev){
    var toggle = ev.target.closest('[data-share-toggle]');

    if(toggle){
      ev.preventDefault();
      ev.stopPropagation();
      var d = datos(toggle);
      if(d.raiz === abierto){ cerrar(); return; }
      /* Hoja nativa del sistema (WhatsApp, Instagram, Mail...) SOLO en movil.
         Chrome de escritorio tambien expone navigator.share, pero ahi la hoja del
         sistema no suele traer WhatsApp: en escritorio conviene nuestro menu,
         que lleva a WhatsApp Web. */
      var esMovil = (window.matchMedia && window.matchMedia('(pointer: coarse)').matches) || window.innerWidth <= 1024;
      if(navigator.share && esMovil){
        navigator.share({ title: d.titulo, text: d.titulo, url: d.url })
          .catch(function(){ /* el usuario cancelo: no es un error */ });
        return;
      }
      abrirMenu(d);
      return;
    }

    var copiar = ev.target.closest('[data-share-copy]');
    if(copiar){
      ev.preventDefault();
      var c = datos(copiar);
      var ok = function(){
        copiar.textContent = 'Enlace copiado';
        setTimeout(function(){ copiar.textContent = 'Copiar enlace'; cerrar(); }, 1200);
      };
      if(navigator.clipboard && navigator.clipboard.writeText){
        navigator.clipboard.writeText(c.url).then(ok, ok);
      } else {
        /* respaldo para navegadores sin Clipboard API (o sin https) */
        var t = document.createElement('textarea');
        t.value = c.url; t.setAttribute('readonly',''); t.style.position='fixed'; t.style.opacity='0';
        document.body.appendChild(t); t.select();
        try{ document.execCommand('copy'); }catch(e){}
        document.body.removeChild(t); ok();
      }
      return;
    }

    if(ev.target.closest('[data-share-menu]')){ setTimeout(cerrar, 60); return; }
    cerrar();
  });

  document.addEventListener('keydown', function(ev){ if(ev.key === 'Escape') cerrar(); });
})();
